import { render, staticRenderFns } from "./ChannelFeatures.vue?vue&type=template&id=69e2789e&scoped=true"
import script from "./ChannelFeatures.vue?vue&type=script&lang=js"
export * from "./ChannelFeatures.vue?vue&type=script&lang=js"
import style0 from "./ChannelFeatures.vue?vue&type=style&index=0&id=69e2789e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e2789e",
  null
  
)

export default component.exports